module.exports = __webpack_public_path__ + "img/share-dott.f9ac329f.png";